import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as f } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconWifiOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function _(e, i, r, h, g, t) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--wifi-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Wifi Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M7.988 5.382a.5.5 0 0 1 .68-.194c.448.25.86.56 1.221.924a.5.5 0 0 1-.708.706 4.5 4.5 0 0 0-1-.756.5.5 0 0 1-.193-.68ZM.646.646a.5.5 0 0 1 .708 0L3.43 2.723l.016.017 2.022 2.022a.492.492 0 0 1 .01.01l5.875 5.874a.5.5 0 0 1-.708.708l-2.66-2.662a.5.5 0 0 1-.585-.085 2 2 0 0 0-2.8 0 .5.5 0 0 1-.7-.714 3 3 0 0 1 2.449-.837l-1.39-1.39a4.5 4.5 0 0 0-2.105 1.188.5.5 0 1 1-.708-.708 5.5 5.5 0 0 1 2.013-1.28L2.976 3.683a7 7 0 0 0-1.642 1.1.5.5 0 0 1-.668-.745 8 8 0 0 1 1.566-1.099L.646 1.354a.5.5 0 0 1 0-.708Zm10.02 4.107a6.993 6.993 0 0 0-5.291-1.755.5.5 0 0 1-.09-.996 7.993 7.993 0 0 1 6.048 2.005.5.5 0 0 1-.666.746ZM5.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const S = /* @__PURE__ */ f(u, [["render", _]]);
export {
  S as default
};
//# sourceMappingURL=wifi-off.js.map
